export default "__VITE_ASSET__B1g$ypia__"